/* Lost Culture Studio - product page extras
   1. "Looks good together": loads two recommended prints with their own
      size/frame pickers; each adds straight to the bag.
   2. Info drawers (Paper and sizing, Shipping, Returns) are moved to <body>
      so they open full height; the theme's drawer script opens/closes them. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Info drawers ---------- */
  $$('[data-lcs-info-drawer]').forEach(function (d) {
    var old = document.body.querySelector(':scope > #' + CSS.escape(d.id));
    if (old && old !== d) old.remove();
    document.body.appendChild(d);
  });

  /* ---------- Unframed listing merged into this page ----------
     ?variant=<id of the unframed listing's variant> (e.g. after visiting the
     unframed listing directly) selects that size + "Unframed" on load.
     Runs after the theme's own scripts have set up the form. */
  function selectSiblingFromUrl() {
    var wrap = $('#ProductInfo [data-product-form-wrapper]');
    if (!wrap) return;
    var id = new URLSearchParams(window.location.search).get('variant');
    if (!id) return;
    var data;
    try { data = JSON.parse($('[data-product-json]', wrap).textContent); } catch (e) { return; }
    var v = data.variants.filter(function (x) { return String(x.id) === id && x.sibling; })[0];
    if (!v) return;
    $$('[data-option-index]', wrap).forEach(function (group) {
      var i = Number(group.getAttribute('data-option-index'));
      var input = $$('[data-option-input]', group).filter(function (el) { return el.value === v.options[i]; })[0];
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(selectSiblingFromUrl, 0); });
  } else {
    setTimeout(selectSiblingFromUrl, 0);
  }

  /* ---------- Looks good together ---------- */
  var root = $('[data-lcs-pair]');
  if (!root) return;
  var grid = $('[data-lcs-pair-grid]', root);

  var routes = (window.theme && window.theme.routes) || {};
  var cartAddUrl = (routes.cartAdd || '/cart/add') + '.js';
  var cartUrl = (routes.cart || '/cart') + '.js';

  function frameKey(v) {
    v = String(v || '').toLowerCase();
    if (/unframed|no frame|none|^-$/.test(v)) return 'none';
    if (v.indexOf('black') > -1) return 'black';
    if (v.indexOf('white') > -1) return 'white';
    if (/wood|oak|natural/.test(v)) return 'wood';
    return 'other';
  }
  function normName(n) {
    n = String(n || '').toLowerCase().replace(':', '').trim();
    if (n === 'frame color' || n === 'frame colour') return 'frame';
    return n;
  }

  /* The main product's chosen variant, so the cards can start on the same size/frame */
  var mainWrap = $('#ProductInfo [data-product-form-wrapper]');
  var mainData = null;
  try { mainData = JSON.parse($('[data-product-json]', mainWrap).textContent); } catch (e) {}
  function mainVariant() {
    if (!mainData || !mainWrap) return null;
    var id = Number(($('[data-variant-id]', mainWrap) || {}).value);
    for (var i = 0; i < mainData.variants.length; i++) if (mainData.variants[i].id === id) return mainData.variants[i];
    return null;
  }
  function mainValues(idx) {
    var seen = [];
    mainData.variants.forEach(function (v) { if (seen.indexOf(v.options[idx]) === -1) seen.push(v.options[idx]); });
    return seen;
  }

  function Card(el) {
    this.el = el;
    this.data = JSON.parse($('[data-lcs-pair-json]', el).textContent);
    this.form = $('[data-lcs-pair-form]', el);
    this.idInput = $('[data-lcs-pair-id]', el);
    this.btn = $('[data-lcs-pair-add]', el);
    this.label = $('[data-lcs-pair-label]', el);
    this.err = $('[data-lcs-pair-error]', el);
    this.touched = false;
    var self = this;
    this.form.addEventListener('change', function () { self.touched = true; self.update(); });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.add(); });
    this.update();
  }
  Card.prototype.chosen = function () {
    var out = {};
    $$('select[data-opt-index]', this.form).forEach(function (s) { out[s.getAttribute('data-opt-index')] = s.value; });
    $$('input[data-opt-index]:checked', this.form).forEach(function (r) { out[r.getAttribute('data-opt-index')] = r.value; });
    return out;
  };
  Card.prototype.variant = function () {
    var chosen = this.chosen();
    var matches = this.data.variants.filter(function (v) {
      for (var k in chosen) if (v.options[k] !== chosen[k]) return false;
      return true;
    });
    return matches.filter(function (v) { return v.available; })[0] || matches[0] || null;
  };
  Card.prototype.update = function () {
    var v = this.variant();
    this.err.hidden = true;
    if (!v) {
      this.btn.disabled = true;
      this.label.textContent = 'Unavailable';
      return;
    }
    this.idInput.value = v.id;
    this.btn.disabled = !v.available;
    this.label.textContent = v.available ? 'Add — ' + v.price : 'Sold out';
  };
  /* Start each card on the same size and frame as the main print */
  Card.prototype.mirror = function () {
    if (this.touched || !mainData) return;
    var mv = mainVariant();
    if (!mv) return;
    var self = this;
    this.data.options.forEach(function (name, ci) {
      var n = normName(name);
      var mi = -1;
      mainData.options.forEach(function (mn, j) { if (normName(mn) === n) mi = j; });
      if (mi === -1) return;
      var want = mv.options[mi];
      var select = $('select[data-opt-index="' + ci + '"]', self.form);
      if (select) {
        var vals = Array.prototype.map.call(select.options, function (o) { return o.value; });
        var pick = vals.indexOf(want) > -1 ? want : null;
        if (!pick && n === 'size') pick = vals[mainValues(mi).indexOf(want)] || null;
        if (pick) select.value = pick;
        return;
      }
      var radios = $$('input[data-opt-index="' + ci + '"]', self.form);
      var hit = radios.filter(function (r) { return r.value === want; })[0] ||
                radios.filter(function (r) { return r.getAttribute('data-frame-key') === frameKey(want); })[0];
      if (hit) hit.checked = true;
    });
    this.update();
  };
  Card.prototype.add = async function () {
    var v = this.variant();
    if (!v || !v.available) return;
    var self = this;
    this.btn.disabled = true;
    this.btn.classList.add('is-loading');
    this.label.textContent = 'Adding…';
    try {
      var res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');

      // Refresh the bag drawer and the header count, then open the bag
      if (data.sections && data.sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        var fresh = $('[data-cart-drawer]', doc);
        var current = $('[data-cart-drawer]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      try {
        var cart = await (await fetch(cartUrl, { headers: { Accept: 'application/json' } })).json();
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      } catch (e) {}

      this.label.textContent = 'Added';
      this.btn.classList.add('is-added');
      var opener = $('[data-open-drawer="cart"]');
      if (opener && $('[data-drawer="cart"]')) opener.click();
      setTimeout(function () { self.btn.classList.remove('is-added'); self.update(); }, 2200);
    } catch (err) {
      this.err.textContent = err.message;
      this.err.hidden = false;
      this.update();
    } finally {
      this.btn.classList.remove('is-loading');
    }
  };

  var cards = [];

  function fetchResults(intent) {
    return fetch(root.getAttribute('data-url') + '&intent=' + intent)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('[data-lcs-pair-item]', doc);
        return items.length ? items : null;
      })
      .catch(function () { return null; });
  }

  fetchResults('complementary')
    .then(function (items) { return items || fetchResults('related'); })
    .then(function (items) {
      if (!items) return;
      items.forEach(function (item) { grid.appendChild(document.importNode(item, true)); });
      root.classList.toggle('lcs-pair--single', items.length === 1);
      root.hidden = false;
      cards = $$('[data-lcs-pair-item]', grid).map(function (el) { return new Card(el); });
      cards.forEach(function (c) { c.mirror(); });
    });

  // Follow the main print's size/frame until the shopper changes a card themselves
  if (mainWrap) {
    mainWrap.addEventListener('change', function () {
      setTimeout(function () { cards.forEach(function (c) { c.mirror(); }); }, 60);
    });
  }
})();
